import { C, F } from '../../tokens';
import { PILOT_0_SUBJECT_ID } from './config';
import PulseTab from './tabs/PulseTab';
import BusinessIntelligenceTab from './tabs/BusinessIntelligenceTab';
import DataSourcesTab from './tabs/DataSourcesTab';
import LearningTab from './tabs/LearningTab';

// Compass shell. Renders an internal tab strip + the active tab. Tabs live in
// separate files under ./tabs. The Business Understanding state AND the active
// internal tab are LIFTED into Portal (passed in via businessUnderstanding /
// setBusinessUnderstanding) so both survive leaving Compass for another Portal
// tab and returning. Frontend-only — no data layer.
const COMPASS_TABS = [
  { id:"pulse",    label:"Pulse",                 Component:PulseTab },
  { id:"bi",       label:"Business Intelligence", Component:BusinessIntelligenceTab },
  { id:"sources",  label:"Data Sources",          Component:DataSourcesTab },
  { id:"learning", label:"Learning",              Component:LearningTab },
];

export default function CompassModule({ client, businessUnderstanding = {}, setBusinessUnderstanding } = {}) {
  // Active internal tab lives inside the lifted state object (reserved `activeTab`
  // key — option b), so returning to Compass lands on the tab the user left, not
  // Pulse. The Business Understanding experience is oblivious to activeTab; its
  // setters all spread {...prev,...}, so this key is preserved across its updates.
  const active = businessUnderstanding?.activeTab || "pulse";
  const setActive = (id) => setBusinessUnderstanding && setBusinessUnderstanding(prev => ({ ...prev, activeTab: id }));
  const ActiveTab=(COMPASS_TABS.find(t=>t.id===active)||COMPASS_TABS[0]).Component;

  const companyName = client?.company || client?.user?.name || client?.name || undefined;

  return (
    <div style={{display:"flex",flexDirection:"column",gap:20}}>
      {/* Internal tab strip */}
      <div style={{display:"flex",gap:4,borderBottom:`1px solid ${C.border}`}}>
        {COMPASS_TABS.map(t=>{
          const on=t.id===active;
          return (
            <button key={t.id} onClick={()=>setActive(t.id)}
              style={{
                background:"none",border:"none",cursor:"pointer",
                padding:"9px 14px",marginBottom:-1,
                fontFamily:F.body,fontSize:13,fontWeight:on?600:500,
                color:on?C.navy:C.charMid,
                borderBottom:`2px solid ${on?C.navy:"transparent"}`,
              }}>
              {t.label}
            </button>
          );
        })}
      </div>

      {/* Active tab */}
      {/* TEMPORARY — Pilot 0 defense in depth. subjectId is pinned: it resolves
          to PILOT_0_SUBJECT_ID only when the client already IS that subject,
          and to null for every other client, so a mis-render cannot address
          another subject's intel rows. The primary restriction is the render
          gate in Portal.js; remove both when Pilot 0 ends. */}
      {active === "bi" ? (
        <ActiveTab companyName={companyName} subjectId={client?.id === PILOT_0_SUBJECT_ID ? PILOT_0_SUBJECT_ID : null} persistedState={businessUnderstanding} onStateChange={setBusinessUnderstanding}/>
      ) : (
        <ActiveTab/>
      )}
    </div>
  );
}
